/* ============================================================
   INDSO — collection.js
   Collection page no longer has filters or sorting (small catalog).
   This file now only powers the collection banner's read-more
   toggle. Filtering/sorting/AJAX logic was removed.
   ============================================================ */
(function () {
  'use strict';

  const ready = (fn) =>
    document.readyState !== 'loading'
      ? fn()
      : document.addEventListener('DOMContentLoaded', fn);

  /* Read more / less (collection banner) */
  function initReadMore() {
    document.querySelectorAll('[data-readmore]').forEach((desc) => {
      const btn = desc.querySelector('[data-readmore-toggle]');
      if (!btn) return;
      btn.addEventListener('click', () => {
        const open = desc.classList.toggle('open');
        btn.textContent = open
          ? (window.INDSOStrings && window.INDSOStrings.readLess) || 'Read less'
          : (window.INDSOStrings && window.INDSOStrings.readMore) || 'Read more';
      });
    });
  }

  ready(initReadMore);
})();
